import { useContextSelector as useCS } from "use-context-selector"
import { useEffect } from "react"

import { DictionaryKeysEnum } from "domain/globalConfig/dictionary/enums/DictionaryKeysEnum"
import { GlobalConfigContext } from "domain/globalConfig/GlobalConfigContext"
import { globalConfigSelectors } from "domain/globalConfig/selectors"

import { useFetchDictionary } from "./useFetchDictionary"
import { TDictionariesInitState } from "../types"

export const useInitDictionary = (key: DictionaryKeysEnum, url: string) => {
  const update = useCS(GlobalConfigContext, globalConfigSelectors.update)

  const { data, error, isLoading } = useFetchDictionary(url)

  useEffect(() => {
    if (isLoading) return
    update({
      dictionaries: {
        [key]: { data: data || [], error: null },
      } as TDictionariesInitState,
    })
  }, [isLoading])

  useEffect(() => {
    if (!error) return
    update({
      dictionaries: {
        [key]: { data: [], error },
      } as TDictionariesInitState,
    })
  }, [error])
}
